import React from 'react';
import { Gauge } from 'lucide-react';

interface RecipeSectionProps {
  line: string;
  isMainSection: boolean | null;
  useThermomix?: boolean;
}

export const RecipeSection: React.FC<RecipeSectionProps> = ({
  line,
  isMainSection,
  useThermomix
}) => {
  if (!line.trim()) return null;

  // Handle bullet points
  if (line.startsWith('-') || line.startsWith('*')) {
    return (
      <li className="text-gray-700 ml-4">
        {line.substring(1).trim()}
      </li>
    );
  }

  // Handle numbered steps
  if (isMainSection) {
    return (
      <div className="flex items-start gap-3 mb-4">
        {useThermomix && <Gauge size={18} className="text-orange-500 mt-1" />}
        <p className="text-gray-800 font-medium">{line}</p>
      </div>
    );
  }

  // Handle regular text
  return (
    <p className="text-gray-700">
      {line}
    </p>
  );
};